A non-negative integer in the minor currency unit for the ISO currency code.

For example, this is the number of cents in dollar-denominated currencies.

The currency of the tax value matches the parent `AdvertisementProductPriceDetails.currency`.
